import type { FaireProductEntity } from "../../entity_types/product";

export const p_7p4hfz5jhs: FaireProductEntity = {
  token: "p_7p4hfz5jhs",
  type: "product",
  name: "ACTIVE CROP TOP AND LEGGINGS SET",
  brandToken: "b_xdgzc3qxkf",
  brandName: "ITSSY",
  imageUrl:
    "https://cdn.faire.com/fastly/c5059278abed1d90587ed3440c9e5632fa628320a2e5c116d293832750c3881b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f13af61318cc929b683caaa51f00c2692100059522bee5256583341bb72acdd3.jpeg",
    "https://cdn.faire.com/fastly/c7fb4f7408c494d3c28c4253d730db87668bb4aeaaa1d5881e73321308347834.jpeg",
    "https://cdn.faire.com/fastly/347743f373b1d0d4d2be83f1214aae2d9cdebe73c03bdf4a36556f1b94f65d67.jpeg",
    "https://cdn.faire.com/fastly/160f134cba7de1d6b58ec0d6f6a5a8c62dd78c1a07fb4e9842e93ad037378e28.jpeg",
    "https://cdn.faire.com/fastly/e8a83c9c004cb62722e8d3eb94626e5259df5cf6957e05d1497629972151e57c.jpeg",
    "https://cdn.faire.com/fastly/47bfe9f7794fea4c4fde18816f3851aa13caadc3fd38362c3264228f01700b01.jpeg",
    "https://cdn.faire.com/fastly/00e1a60e47463f74f9fbf825dda9a9d63a6d45d2b32041795721d04add1b8c5d.jpeg",
    "https://cdn.faire.com/fastly/f94c2201d328fb3701790f1de2d4255ee6fbca32a4bed95f223cfee1be187303.jpeg",
    "https://cdn.faire.com/fastly/38952c81c9f3e05efe917f1f4bd47c087a19f6f7fd0a7b47e5999670a16ef326.jpeg",
    "https://cdn.faire.com/fastly/195e8431de75ff9fd71c677170914ba8baca62b00305e411f7f9e75854cf293e.jpeg",
    "https://cdn.faire.com/fastly/c1e68049f3514258058037e247572417204bb20fbd512fcbc5ab1f34e4e1568a.jpeg",
    "https://cdn.faire.com/fastly/134b24f71edd42b4d3568cc24cfebba9ff8a248d30fe3f13b190210b5c8dd9db.jpeg",
  ],
  priceDollars: 13.65,
  description:
    "SKU : ISET67351AC..\r\n\r\n*** New Style ***\r\nROUND NECK DOUBLE LAYER EFFECT CROP TOP AND HIGH WAIST CONTRAST WAISTBAND LEGGINGS SET\r\n- CROP TOP \r\n- HIGH WAIST\r\n92% NYLON 8% SPANDEX\r\n",
  tags: [],
  msrpDollars: 27.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:36.643Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
